module.exports = __webpack_public_path__ + "static/img/7bg_7.dd0b722.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_7.png
// module id = 744
// module chunks = 1